import styled from 'styled-components'
import { theme } from '~/styles'

export const Container = styled.div`
  display: grid;
  flex: 1;
  text-align: center;
  margin-top: ${({ theme }) => theme.zds.size.variant190};
  margin-bottom: ${({ theme }) => theme.zds.spacing.stack500};
  & svg {
    fill: ${theme.colors.color378ff7};
  }
`

interface ILoading {
  isLoading: boolean
}

export const Title = styled.div`
  margin-top: 32px;
`

export const ContentLoading = styled.div<ILoading>`
  opacity: ${({ isLoading }) => (isLoading ? 1 : 0)};
  transition: opacity 0.3s;
  transition: all 0.3s;
  color: ${props => props.theme.colors.color2e384d};
  font-size: 16px;
  grid-area: 1 / 1;
`

export const ContentLoaded = styled.div<ILoading>`
  opacity: ${({ isLoading }) => (!isLoading ? 1 : 0)};
  visibility: ${({ isLoading }) => (!isLoading ? 'visible' : 'hidden')};
  transition: visibility 0.3s 0.3s;
  font-weight: 500;
  color: ${props => props.theme.colors.color545e6c};
  font-size: 20px;
  grid-area: 1 / 1;
`
